import React from 'react';
import { IconButton } from 'rsuite';

export function ModalIcon(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <IconButton {...props} />;
}
